import { Navigate } from 'react-router-dom';
import storage from '../assets/js/Global';

const PublicRoute = ({ children }) => {
    const loginObj = storage.get('user');
    const isAuthenticated = loginObj && loginObj.user_pid;

    if (isAuthenticated) {
        return <Navigate to={'/home'} replace />;
    }

    return children;
};

export { PublicRoute };